import React from 'react'
import styled, { css } from 'styled-components'

import { centerChildrenMixin } from '../Center'
import { brkmax, brkmin, themeColor } from '../theme'

interface ButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  checked?: boolean
  disabled?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const BaseButton = ({ checked, disabled, onClick, ...rest }: ButtonProps) => (
  // @ts-ignore
  <div onClick={disabled ? undefined : onClick} {...rest} />
)

const buttonMixin = ({ checked, disabled }: ButtonProps) => css`
  ${centerChildrenMixin}
  height: 48px;
  cursor: ${disabled ? 'not-allowed' : 'pointer'};
  background-color: ${({ theme: { colors } }) => (checked ? colors.lightestGray : colors.white)};
  color: ${themeColor('primary')};
  padding: 0;
  border: solid 1px ${themeColor('gray')};

  font-size: 14px;
  line-height: 1.71;
  text-align: center;
  font-weight: 500;

  ${brkmin(
    0,
    css`
      &:not(:last-of-type) {
        border-right: 0;
      }

      &:first-of-type {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }

      &:last-of-type {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        border-right: solid 1px ${themeColor('gray')};
      }
    `
  )}

  ${brkmax(
    0,
    css`
      &:not(:first-of-type) {
        border-top: 0;,
        border-right: solid 1px ${themeColor('gray')};
      }

      &:first-of-type {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }

      &:last-of-type {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
        border-bottom: solid 1px ${themeColor('gray')};
      }
    `
  )}
`

export const TabButton = styled(BaseButton)`
  ${buttonMixin}
  width: 100%;
`
